<template>
<div class="contact-hub" :class="{ 'is-light': theme === 'light' }" @mouseleave="hoveredContact = null" @focusout="leaveFocus">
        <div class="contact-icons" role="group" :aria-label="language === 'zh' ? '联系纪煜科技' : 'Contact JIYU'">
          <button v-for="item in contacts" :key="item.id" type="button" class="contact-icon" :class="{ active: visibleContact === item.id }" :aria-label="item.label" :aria-expanded="visibleContact === item.id" aria-controls="contact-details" @mouseenter="hoveredContact = item.id" @focus="focusContact(item.id)" @click="toggleContact(item.id)">
            <span class="material-symbols-rounded" aria-hidden="true">{{ item.icon }}</span>
          </button>
        </div>
        <div class="contact-detail-slot">
          <Transition name="contact-reveal" mode="out-in">
            <div v-if="selectedContact" id="contact-details" :key="selectedContact.id" class="contact-details" role="region" :aria-label="selectedContact.label">
              <span class="contact-detail-label">{{ selectedContact.label }}</span>
              <a v-if="selectedContact.href" :href="selectedContact.href">{{ selectedContact.value }}</a>
              <p v-else>{{ selectedContact.value }}</p>
            </div>
          </Transition>
        </div>
      </div>
</template>

<script>
export default {
  name: 'ContactIcons',
  props: { language: { type: String, default: 'zh' }, theme: { type: String, default: 'dark' } },
  data: () => ({ hoveredContact: null, focusedContact: null, pinnedContact: null }),
  computed: {
    contacts() { const zh = this.language === 'zh'; return [
      { id: 'phone', icon: 'call', label: zh ? '电话' : 'Phone', value: '176 0570 2079', href: 'tel:17605702079' },
      { id: 'email', icon: 'mail', label: zh ? '邮箱' : 'Email', value: 'nbjy@nbjiyu-tech.cn', href: 'mailto:nbjy@nbjiyu-tech.cn' },
      { id: 'address', icon: 'location_on', label: zh ? '地址' : 'Address', value: zh ? '浙江省宁波市海曙区翠柏路89号C座4楼409' : 'Room 409, 4F, Building C, 89 Cuibai Road, Haishu, Ningbo, Zhejiang' }
    ] },
    visibleContact() { return this.hoveredContact || this.pinnedContact || this.focusedContact },
    selectedContact() { return this.contacts.find(item => item.id === this.visibleContact) }
  },
  mounted() { window.addEventListener('keydown', this.onEscape); document.addEventListener('pointerdown', this.dismissOutside) },
  beforeUnmount() { window.removeEventListener('keydown', this.onEscape); document.removeEventListener('pointerdown', this.dismissOutside) },
  methods: {
    focusContact(id) { this.hoveredContact = null; this.focusedContact = id; if (this.pinnedContact !== id) this.pinnedContact = null },
    onEscape(event) { if (event.key === 'Escape') this.closeDetails() },
    toggleContact(id) {
      if (this.pinnedContact === id) this.closeDetails()
      else this.pinnedContact = id
    },
    closeDetails() { this.hoveredContact = null; this.focusedContact = null; this.pinnedContact = null },
    leaveFocus(event) { if (!event.currentTarget.contains(event.relatedTarget)) { this.focusedContact = null; this.pinnedContact = null } },
    dismissOutside(event) { if (!this.$el.contains(event.target)) this.closeDetails() }
  }
}
</script>

<style scoped>
.contact-hub{width:100%;max-width:420px;text-align:left}
.contact-icons{display:flex;justify-content:flex-start;gap:18px}
.contact-icon{width:44px;height:44px;display:grid;place-items:center;border:1px solid rgba(255,255,255,.23);border-radius:50%;background:transparent;color:#b5bbc1;cursor:pointer;transition:color .25s,border-color .25s,translate .25s,background-color .7s}
.contact-icon .material-symbols-rounded{font-size:20px;font-variation-settings:'FILL' 0,'wght' 300,'GRAD' 0,'opsz' 24}
.contact-icon.active,.contact-icon:hover{color:#fff;border-color:#fff;translate:0 -3px}
.contact-icon:focus-visible,.contact-details a:focus-visible{outline:2px solid var(--accent);outline-offset:5px}
.contact-detail-slot{min-height:78px;padding-top:12px}
.contact-details{color:#f7f8fa;font-size:14px;line-height:1.65;overflow-wrap:anywhere;transition:color .7s}
.contact-detail-label{display:block;font-size:10px;letter-spacing:.12em;color:#939ba3;margin-bottom:4px}
.contact-details a{color:inherit;text-decoration:none}
.contact-details a:hover{text-decoration:underline;text-underline-offset:4px}
.contact-details p{font-size:12px;user-select:text}
.contact-reveal-enter-active,.contact-reveal-leave-active{transition:opacity .18s ease,transform .18s ease}
.contact-reveal-enter-from,.contact-reveal-leave-to{opacity:0;transform:translateY(6px)}

.is-light .contact-detail-label{color:#5d656d}
.is-light .contact-icon{color:#505962;border-color:rgba(12,17,22,.25)}
.is-light .contact-icon.active,.is-light .contact-icon:hover{color:#111417;border-color:#111417}
.is-light .contact-details{color:#111417}
@media(prefers-reduced-motion:reduce){.contact-icon,.contact-reveal-enter-active,.contact-reveal-leave-active{transition:none}.contact-icon.active,.contact-icon:hover{translate:none}}
@media(min-width:981px){
  .contact-icons{gap:12px}
  .contact-icon{width:32px;height:32px}
  .contact-icon .material-symbols-rounded{font-size:14px}
  .contact-detail-slot{min-height:62px;padding-top:10px}
  .contact-details{font-size:12px}
  .contact-detail-label{font-size:8px}
  .contact-details p{font-size:10px}
}
@media(max-width:980px){.contact-icon .material-symbols-rounded{font-size:16px}}
</style>
